import styled from 'styled-components/macro';
import * as colors from '../../../../common/colorConstants';

const TransactionRow = styled.div`
  background: ${colors.lightGray7};
  border-bottom: 1px solid ${colors.lightGray15};
  padding-bottom: 10px;
`;

const ItemRow = styled.div`
  display: flex;
  padding: 5px 15px 3px 30px;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0px;
`;

const Count = styled.span`
  margin-right: 5px;
`;

const NoData = styled.span`
  color: ${colors.lightGray1};
`;

const CenterPos = styled.div`
  margin: 0 auto;
`;

const DetailsButton = styled.button`
  border-radius: 3px;
  width: 18px;
  height: 18px;
  background-color: ${colors.white};
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
  background-image: url(${({ open }) => `/images/arrows/down-arrow-${open ? 'blue' : 'gray'}.svg`});
  transform: ${({ open }) => (open ? `rotateX(180deg)` : `rotateX(0)`)};
  border: 1px solid ${({ open }) => (open ? colors.blue1 : colors.lightGray1)};
`;

export { TransactionRow, ItemRow, Count, NoData, CenterPos, DetailsButton };
